module.exports = "<div class=\"pageHeader wow FadeInLegacyUp\" data-wow-delay=\".4s\">\n  <h1 class=\"accessibility-page-header\">{{ headerName }}</h1>\n  <p *ngIf=\"headerTitle\" class=\"pageBreadcrumbs page-subheader-row\">\n    <a [routerLink]=\"['/']\" class=\"accessible\" href=\"javascript:void(0)\" tabindex=\"0\">עמוד ראשי</a>\n    <img alt=\"chevron-left\"   class=\"chevron-left-icon\" src=\"../../assets/svg/chevron-left.svg\">\n\n    {{ headerTitle }}\n  </p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/_directives/pageheader.component.html
// module id = ./src/app/_directives/pageheader.component.html
// module chunks = main